/** @format */
import { ReactNode } from 'react';

import {
    PaginationItemProps,
    PaginationVariant,
} from '@toucan/client/shared/components/pagination';

export enum CarouselVariant {
    MINIMAL = 'minimal',
    FULL = 'full',
}

export type CarouselProps = {
    'data-testid'?: string;
    className?: string;
    showPagination?: boolean;
    showExpandButton?: boolean;
    initialPage?: number;
    imageAspectRatio?: string;
    maxSlideHeight?: string;
    onFocussedItemClick?: (index: number) => void;
    onActiveIndexChange?: (index: number) => void;

    /**
     * Variant of the carousel
     *
     * @default MINIMAL
     */
    variant?: CarouselVariant;

    /**
     * The items to be displayed in the carousel
     */
    items: ReactNode[];

    /**
     * The display variant of the pagination item to be displayed.
     * No pagination is displayed if this property is not passed.
     *
     * @default DOT
     */
    paginationVariant?: PaginationVariant;

    /**
     * The items to be displayed in the pagination
     */
    paginationItems?: PaginationItemProps[];
    note?: string;
};

export type StyledCarouselProps = CarouselProps & {
    showNextButton: boolean;
    showPrevButton: boolean;
};

export type CarouselModalProps = Pick<
    CarouselProps,
    | 'className'
    | 'data-testid'
    | 'initialPage'
    | 'onActiveIndexChange'
    | 'items'
    | 'paginationItems'
    | 'note'
>;
